import { LineString } from 'geojson';

export interface RoutePath {
  path: [number, number][];
  start: {
    lat: number;
    lng: number;
  };
  end: {
    lat: number;
    lng: number;
  };
}

export const lineStringToRoutePath = <T extends LineString | null | undefined>(
  lineString: T,
): T extends LineString
  ? RoutePath
  : T extends null | undefined
    ? T
    : never => {
  if (!lineString) {
    return lineString as any;
  }

  const coords = lineString.coordinates;

  return {
    path: coords.map(([lng, lat]) => [lat, lng] as [number, number]),
    start: {
      lat: coords[0][1],
      lng: coords[0][0],
    },
    end: {
      lat: coords[coords.length - 1][1],
      lng: coords[coords.length - 1][0],
    },
  } as any;
};
